import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import admin, { getMenuItem, getPriceForQuantity } from "../../js/admin";
import "./customerScreen.css"
import auth from "../../js/auth";
import { stopIntervals } from "../../js/point-of-sale";
import TipPicker from "../../components/tipPicker";
import ThankYouAnimation from "../../components/ThankYouAnimation";
import { get } from "jquery";

const thanksDuration = 8000;
const tipTimeout = 150000; //10 seconds

class CustomerScreen extends Component {

    state = {
        ... (sessionStorage.customerScreenData ? JSON.parse(sessionStorage.customerScreenData) : {

            orders: [],
            index: 0,
        }),
        tip: 0,
        channel: null,
        initialized: false,
        askForTip: false,
        paymentComplete: false,
    };

    componentDidUpdate = () => {
        if (auth?.device?.platform === "Android") {
        }

    }

    handler = (event) => {

        let message = event?.data ?? event?.detail?.data;
        if (typeof message === "string") {
            try {
                message = JSON.parse(message);
            } catch {
                return;
            }
        }

        const { data, images = [], tip } = message || {};
        const type = message?.type || data?.type;
        if (!type) {
            return;
        }
        if (data && type === "check") {
            this.sendMessage({ check: "ready" });
        } else if (type === "askForTip") {
            this.setState({ askForTip: true, tipSelected: false, tip: 0, paymentComplete: false });
        } else if (type === "cancelAskForTip") {
            this.setState({ askForTip: false, tipSelected: false });
        } else if (type === "thanks") {
            this.completedOrderIds = new Set((message.orderIds || []).map(String));
            this.completedOccupation = message.tableOccupation;
            this.setState({ orders: [], tip: 0, askForTip: false, tipSelected: false, paymentComplete: true });
            clearTimeout(this.thanksTimer);
            this.thanksTimer = setTimeout(() => this.setState({ paymentComplete: false }), thanksDuration);
        } else if (type === "update") {
            const orders = Array.isArray(data) ? data.filter(group =>
                !this.completedOrderIds ||
                String(group.tableOccupation) !== String(this.completedOccupation) ||
                group.orderIds?.some(id => !this.completedOrderIds.has(String(id)))
            ) : null;

            this.setState(state => ({
                ...(orders ? {
                    orders,
                    images,
                    index: Math.min(state.index, images.length),
                    paymentComplete: state.paymentComplete && orders.length === 0,
                } : {}),
                ...(orders?.length === 0 ? { tip: 0, askForTip: false, tipSelected: false }
                    : tip !== undefined ? { tip } : {}),
            }));
            setTimeout(() => {
                this.sendMessage({ check: "ready" });
            }, 500);
        }
        this.sendMessage({ check: "ok" });
        localStorage.setItem("msg", JSON.stringify({ check: "ok", timestamp: new Date().getTime() }));
        return;
    }


    componentDidMount = () => {

        if (this?.state?.channel) return;
        const channel = new BroadcastChannel('customerScreen');

        this.setState({ channel: channel });

        channel.onmessage = this.handler;
        /* this is working */
        document.addEventListener("message", this.handler);

        if (navigator?.presentation?.onpresent) {
            navigator.presentation.onpresent = (event) => {
                alert("Presentation session started on customer screen");
                if (event.session) {
                    alert("Customer screen presentation session established, setting up message handler");
                    const session = event.session;
                    session.onmessage = (msg) => {
                        alert("Customer screen received message " + JSON.stringify(msg));
                        this.handler(msg);
                    };
                }
            };
        } else {
        }

        this.interval = setInterval(this.nextPicture, 3000);

        admin.getActiveMenuItems(data => {
            admin.categories = data;
            this.setState({ initialized: true });
        })
    }

    componentWillUnmount = () => {
        clearTimeout(this.thanksTimer);
        stopIntervals(this.interval);
    }

    nextPicture = () => {
        if (this?.state?.channel)
            this.sendMessage({ source: this.props.match.params.tableNumber, check: "ready" });

        if (this.state.images)
            this.setState({ index: this.state.index < this.state.images.length - 1 ? this.state.index + 1 : 0 })
    }

    sendMessage = (message) => {
        try {
            if (sessionStorage.customerScreen && sessionStorage.customerScreen !== "null") {
                message.CustomerScreen = sessionStorage.customerScreen;
                message.Restaurant = localStorage.restaurantSelected;
                auth.sendMessage2(message);
            } else {
                this.state.channel.postMessage(message, window.location.href);
            }
        } catch (e) {
            this.state.channel.postMessage(message, window.location.href);
        }
    }

    render() {
        const restaurantCss = this.props.myStatus.restaurant_css?.trim();
        return (
            <>
                {restaurantCss && <style>{restaurantCss}</style>}
                {this.renderScreen(restaurantCss ? "customerScreen" : "customerScreen customerScreenDefault")}
            </>
        );
    }

    renderScreen(screenClass) {
        sessionStorage.customerScreenData = JSON.stringify(this.state);

        if (!this.props.myStatus.restaurant_base_currency || !admin.categories || !this.state.initialized)
            return null;

        if (this.state.askForTip && !this.state.tipSelected) {
            if (this.tipTimeout) clearTimeout(this.tipTimeout);
            this.tipTimeout = setTimeout(() => {
                clearTimeout(this.tipTimeout);
                if (this.state.askForTip && !this.state.tipSelected) {
                    this.setState({ tipSelected: true }, () => {
                        this.sendMessage({ type: "tipSelected", tip: 0 });
                    });
                }
                //   this.setState({ askForTip: true, tipSelected: true, tip: 0 });
            }, tipTimeout);
        } else {
            if (this.tipTimeout) clearTimeout(this.tipTimeout);
        }

        if (this.state.orders && this.state.orders.length === undefined) {
            return null;
        }

        if (this.state.paymentComplete) {
            return (
                <div className={screenClass + " customerScreenThanks"} role="status">
                    <ThankYouAnimation />
                </div>
            );
        }

        const restaurantImageBase = auth.server + "/" + auth.war + "/tableService/" + localStorage.restaurantSelected;
        const logoTimestamp = this.props.myStatus.restaurant_logo_image;
        const logoInstance = "instance=" + encodeURIComponent(localStorage.instance || "");
        const profileLogo = auth.server + "/" + auth.war + "/tableService/"
            + this.props.myStatus.restaurant_global_id + "/getRestaurantImage.png?" + logoInstance;
        const namedLogo = restaurantImageBase + "/getImageByName/logo?timestamp=" + logoTimestamp + "&" + logoInstance;
        const restaurantLogo = !this.state.askForTip && [
            logoTimestamp > 0 ? namedLogo : null,
            profileLogo,
        ].find(url => url && !this.state.failedRestaurantLogos?.includes(url));

        const restaurantLogoImage = restaurantLogo ? (
            <span className="customerRestaurantLogoFrame" key={restaurantLogo}>
                <img
                    className="customerRestaurantLogo"
                    alt={this.props.myStatus.restaurant_name || ""}
                    src={restaurantLogo}
                    onError={() => this.setState(state => ({
                        failedRestaurantLogos: [...(state.failedRestaurantLogos || []), restaurantLogo],
                    }))}
                />
            </span>
        ) : null;

        if (!this.state.askForTip && !this.state.orders?.length) {
            return (
                <div className={screenClass + " customerScreenWelcome"} role="status">
                    <div className="customerWelcomeContent">
                        {restaurantLogoImage}
                        <div>
                            <div className="customerWelcomeTitle">Üdvözöljük!</div>
                            <div className="customerWelcomeSubtitle">Welcome!</div>
                        </div>
                    </div>
                </div>
            );
        }

        const totalPrice = this.state.orders ? this.state.orders.reduce((a, b) => a + b.price, 0) : 0;

        const screenMode = this.state.askForTip ? " customerScreenTip" : " customerScreenOrdering";

        return (
            <div className={screenClass + screenMode + (this.state.askForTip && this.state.tipSelected ? " customerScreenTipPending" : "")} key="0">
                <div className="orderLevel1" key="1">
                    <div className="customerOrderItems">
                        {this.state?.orders?.map && this.state.orders.map((order, ind) =>
                            <React.Fragment>
                                {order.orders && order.orders.map((order, ind1) =>
                                    order.orders.map((order, ind2) =>
                                        <React.Fragment>
                                            <div key={order.orderIds + ".1"} className="count">{order.orderCount}  x&nbsp;</div>
                                            <div key={order.orderIds + ".2"} className="name">{order.menuItem.name} {this.getQuantity(order)}</div>
                                            <div key={order.orderIds + ".3"} className="unitPrice">{getPriceForQuantity(getMenuItem(order.menuItem.id), order.quantity)}</div>
                                            <div key={order.orderIds + ".4"} className="price">{order.orderCount * order.price} {this.props.myStatus.restaurant_base_currency.name}</div>
                                            {order.childOrders.map((childOrder, ind3) =>
                                                <React.Fragment>
                                                    <div key={order.orderIds + "." + ind3 + ".1"}></div>
                                                    <div key={order.orderIds + "." + ind3 + ".2"} className="childName">{childOrder.menuItem.name} {this.getQuantity(childOrder)}</div>
                                                    <div key={order.orderIds + "." + ind3 + ".3"} className="childPrice">{(childOrder.addition ? 1 : -1) * childOrder.fullPrice}</div>
                                                    <div key={order.orderIds + "." + ind3 + ".4"}></div>
                                                </React.Fragment>
                                            )}
                                        </React.Fragment>
                                    )
                                )}
                            </React.Fragment>
                        )}
                    </div>
                    <div className="customerOrderTotals">
                        <div key="8" className="count footer">{I18n.t("admin_local.Total price").split('<br/>').map((line, index) => (
                            <React.Fragment key={index}>
                                <div>{line}</div>
                            </React.Fragment>
                        ))}</div>
                        <div key="9" className="price footer">{auth.round(totalPrice)} {this.props.myStatus.restaurant_base_currency.name}</div>
                        {this.props.myStatus.restaurant_currencies.filter(c => c.isActive).map(currency =>
                        (
                            <>
                                <div key={currency.id} className="count footer"></div>
                                <div key={currency.id} className="price footer">{this.applyRoundFunction(currency.currency.javaScriptRoundFunction, this.state.orders.reduce((a, b) => a + b.price / currency.exchangeRate, 0))} {currency.currency.name}</div>
                            </>
                        )
                        )}
                        {this.state.tip > 0 &&
                            (
                                <>
                                    <div key="6" className="count footer">{I18n.t("admin_local.Total tip").split('<br/>').map((line, index) => (
                                        <React.Fragment key={index}>
                                            <div>{line}</div>
                                        </React.Fragment>
                                    ))}</div>
                                    <div key="7" className="price footer">{auth.round(this.state.tip)} {this.props.myStatus.restaurant_base_currency.name}</div>

                                    <div key="10" className="count footer">{I18n.t("admin_local.amount_with_tip").split('<br/>').map((line, index) => (
                                        <React.Fragment key={index}>
                                            <div>{line}</div>
                                        </React.Fragment>
                                    ))}</div>
                                    <div key="11" className="price footer">{auth.round(totalPrice + this.state.tip)} {this.props.myStatus.restaurant_base_currency.name}</div>

                                </>
                            )
                        }
                    </div>
                    <div className="logo" key="logo">
                        <div className="logo2"></div>
                    </div>
                </div>
                <div className="ads" key="2">
                    {this.state.askForTip &&
                        (< TipPicker myStatus={this.props.myStatus} basePrice={totalPrice} thanks={false} onTipSelected={(tip) => {
                            if (this.state.tipSelected) return;
                        this.setState({ tipSelected: true, tip: auth.round((totalPrice * tip) / 100) }, () => {
                            console.log("Tip selected: " + tip);
                            this.sendMessage({ type: "tipSelected", tip: tip });
                            });
                        }} >
                        </TipPicker>)}
                    <div className="ads-img">
                        {restaurantLogoImage ? restaurantLogoImage : this.state.images && this.state.images.length > 0 ?
                            <img alt="" src={auth.server + "/" + auth.war + "/adminService/" + localStorage.restaurantSelected + "/getImage/" + this.state.images[this.state.index]}></img>
                            : !this.state.askForTip && <span className="customerRestaurantName">{this.props.myStatus.restaurant_name}</span>}
                    </div>
                </div>
            </div >)
    }

    applyRoundFunction = (roundFunctionStr, amount) => {
        try {
            if (!roundFunctionStr || roundFunctionStr.trim() === "") {
                return auth.round(amount);
            }
            // Replace 'amount' in the string with the actual numeric value
            const expression = roundFunctionStr.replace(/amount/g, amount);
            // Evaluate safely using Function constructor
            return Function(`"use strict"; return (${expression});`)();
        } catch (e) {
            console.warn("Invalid rounding function, defaulting to Math.round");
            return amount;
        }
    }


    getQuantity = (o) => {
        var menuItem = getMenuItem(o.menuItem.id);
        var quantityType = o.quantityType ? o.quantityType : menuItem.quantityType;
        if (quantityType === "undefined" || quantityType === "" || quantityType === "none") return "";
        var quantityLabel = "";
        var quantity = o.quantity;
        menuItem.availableQuantities.forEach(function (q) {
            if (Math.abs(q.quantity) === Math.abs(quantity)) {
                quantityLabel = q.quantityType ? q.quantityType.name : q.name;
                if (quantityLabel === "N/A") quantityLabel = "";
            }
        });
        if (quantityLabel !== "" && menuItem.entityType === "Meal") {
            return (quantity < 0 ? quantity + " " : "") + quantityLabel;
        } else {
            var v = quantityLabel !== "" ? quantityLabel + " " : "";
            v += Math.abs(quantity) === 1 && quantityType === "pcs" ? "" : "(" + (quantity + (quantity === 1 && quantityType === "pcs" ? "" : quantityType === "" ? "" : " " + I18n.t("local." + quantityType))) + ")";
            return v;
        }
    }


}
const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            speechRecognitionOn: props.rootReducer.speechRecognitionOn,
            ai: props.rootReducer.ai,
            speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
            tables: props.rootReducer.tables
        };
    }
    return {};
};

export default connect(mapStateToProps)(CustomerScreen);
